module.exports = __webpack_public_path__ + "trail_blue.svg";